import { AvatarBadgeProps } from '@factorialco/deprecated-design-system'
import type { TimeInsightsEntitiesClockInStatusStatusEnum } from 'generated/resources/graphql'

export const getStatusBadge = (
  type: TimeInsightsEntitiesClockInStatusStatusEnum
): AvatarBadgeProps => {
  switch (type) {
    case 'missing_clock_in':
      return {
        label: '',
        icon: 'cross',
        color: 'grey000White',
        backgroundColor: 'radicalRed1000',
      }
    case 'clocked_in':
      return {
        label: '',
        icon: 'check',
        color: 'grey000White',
        backgroundColor: 'lime1000',
      }
    case 'in_a_break':
      return {
        label: '',
        icon: 'clock',
        color: 'grey000White',
        backgroundColor: 'champagne1000',
      }
    default:
      return {
        label: '',
        icon: undefined,
        color: 'grey000White',
        backgroundColor: 'champagne1000',
      }
  }
}
